import PropTypes, {InferProps} from "prop-types";
import {PROFILE_DESCRIPTION, ProfileDescriptionInputView} from "./profile-description-input.view";
import {useCallback, useEffect, useState} from "react";
import {currentProfile, usePersonView, useProfile} from "@betrue/front/services";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {ProfileDescriptionInputForm} from "./profile-description-input.form";
import {Asserts} from "yup";
import {CircularProgress} from "@mui/material";


export const ProfileDescriptionInputTypes = {
  cancelButton: PropTypes.string,
  submitButton: PropTypes.string,
  descriptionTitle: PropTypes.string,
  descriptionSubTitle: PropTypes.string,
  textAreaLabel: PropTypes.string,


}
export type ProfileDescriptionInputProps = InferProps<typeof ProfileDescriptionInputTypes>


export const ProfileDescriptionInput = (props: ProfileDescriptionInputProps) => {
  const {
    handleSubmit,
    control,
  } = useForm<Asserts<typeof ProfileDescriptionInputForm>>({
    resolver: yupResolver(ProfileDescriptionInputForm)
  })
  const [isEditable, setEditable] = useState<boolean>()

  const [description, setDescription] = useState<string>()
  const [, viewProfile] = useCallback(usePersonView, [])()
  const [, {updateProfile}] = useCallback(useProfile, [])(currentProfile)
  const handleEditable = () => {
    setEditable(!isEditable)
  }

  const handleDescriptionSubmit = (res) => {
    setEditable(false)
    if (!res.description.includes(PROFILE_DESCRIPTION)) {
      setDescription(res.description)
      updateProfile({...viewProfile, person: {...(viewProfile.person)}, job: {...viewProfile.job}, ...res})
    }
  }

  useEffect(() => {
    if (viewProfile) {
      setDescription(viewProfile.description)
      setEditable(false)
    }
  }, [viewProfile])

  if (!viewProfile) {
    return (<><CircularProgress/></>)
  }


  return (
    <>
      <ProfileDescriptionInputView  {...props}
                                    onSubmit={handleSubmit(handleDescriptionSubmit)}
                                    description={description}
                                    onEdit={handleEditable}
                                    control={control}
                                    isEditable={isEditable}/>
    </>
  );
}

ProfileDescriptionInput.propTypes = ProfileDescriptionInputTypes
